import dayjs from "dayjs";
import { orderBy } from "lodash";
import { useState } from "react";
import { Empty, Tag, Tooltip } from "antd";
import { faClipboardCheck, faList } from "@fortawesome/free-solid-svg-icons";

//STYLE
import { Container, DetailsContainer, ProgressBarContainer } from "./style";

//APP
import { QtdeInoculantes } from "../..";
import { Item__EquipeCliente } from "../../../../../../../../services/Equipe/GET";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../../services/atividades/GET";
import { estruturaListarInsumos, obterInsumoPorTalhao } from "./meta";

//COMPONENTS
import Tabs from "../../../../../../../../Components/Tabs";
import { RowItem } from "../../../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../../../Components/CustomUi/table/rowTable";
import { BodyTable } from "../../../../../../../../Components/CustomUi/table/bodyTable";
import { Accordion } from "../../../../../../../../Components/CustomUi/accordion";
import { SortButton } from "../SortButton";
import { HeaderTable } from "../../../../../../../../Components/CustomUi/table/headerTable";
import { numeroMilhar } from "../../../../../../../../utils";
import { typeInsumosDashboard } from "../../../insumosPrecisao";
import { unidade_medida_local } from "../../../insumosPrecisao/meta";

//PROPS
interface Props {
    insumo_selecionado: typeInsumosDashboard;
    todas_atividades_ativas: Item__Atividades[];
    data_propriedades: ItemPropriedades[];
    data_equipe_cliente: Item__EquipeCliente[];
}

export const ModalDetalhesInsumoInoculantes: React.FC<Props> = ({ insumo_selecionado, todas_atividades_ativas, data_propriedades, data_equipe_cliente }) => {
    if (!insumo_selecionado) return null;

    // const [tipo_grafico, setTipo_grafico] = useState<'Precisão' | 'Distribuição'>('Precisão');
    const [tipo_atividade, setTipo_atividade] = useState<'Planejadas' | 'Executadas'>('Planejadas');
    const [openAccordion, setOpenAccordion] = useState<string | null>(null);
    const [sortType, setSortType] = useState<'executada' | 'planejada' | 'precisao' | 'alfabetica'>('executada');

    const toggleAccordion = (id: string) => {
        setTipo_atividade('Planejadas');
        setOpenAccordion(prev => prev === id ? null : id);
    };

    const { quantidade_planejada, quantidade_executada, precisao, porcentagem, tipo_fisico } = insumo_selecionado;

    const lista_por_talhoes = obterInsumoPorTalhao(todas_atividades_ativas, insumo_selecionado?.cod_insumo, data_propriedades, tipo_fisico) ?? [];

    const lista_ordenada = orderBy(lista_por_talhoes, [
        (item) => {
            if (sortType === 'executada') return item.quantidade_executada;
            if (sortType === 'planejada') return item.quantidade_planejada;
            if (sortType === 'precisao') return item.precisao;
            if (sortType === 'alfabetica') return item.nome_talhao;
            return item.quantidade_executada;
        }
    ], [
        sortType === 'alfabetica' ? 'asc' : 'desc'
    ]);

    function quantidadeEmToneladas(quantidade: number) {
        if (quantidade >= 1000) {
            return `${numeroMilhar(quantidade / 1000)} t`;
        }
        return `${numeroMilhar(quantidade)} kg`;
    };

    function quantidadeEmLitros(quantidade: number) {
        if (quantidade < 1) {
            return `${numeroMilhar(quantidade * 1000)} mL`;
        }
        return `${numeroMilhar(quantidade)} L`;
    };

    return (
        <Container>
            {/* <Tabs
                tabs={[{ descricao: 'Precisão', icone: faChartGantt }, { descricao: 'Distribuição', icone: faChartGantt }]}
                onChange={setTipo_grafico}
                selecionado={tipo_grafico}
            /> */}
            <div className="Container__header">
                <DetailsContainer>
                    <div className="DetailItem planejada">
                        <strong>Planejada</strong>
                        <div className="Value">
                            {tipo_fisico === 'Sólido' ? quantidadeEmToneladas(quantidade_planejada) : quantidadeEmLitros(quantidade_planejada)}
                        </div>
                    </div>

                    <div className="DetailItem executada">
                        <strong>Executada</strong>
                        <div className="Value">
                            {tipo_fisico === 'Sólido' ? quantidadeEmToneladas(quantidade_executada) : quantidadeEmLitros(quantidade_executada)}
                        </div>
                    </div>
                </DetailsContainer>

                <ProgressBarContainer style={{ flex: 1 }}>
                    <span className="ProgressBarContainer__title">Precisão</span>
                    <Tooltip title={`Executado: ${porcentagem}%`}>
                        <div className="ProgressBarContainer__bar">
                            <div
                                className="bar-fill"
                                data-error={precisao < 80}
                                data-warning={precisao >= 80 && precisao < 95}
                                data-small={precisao >= 95 && precisao < 100}
                                data-precise={precisao === 100}
                                style={{ width: `${porcentagem * 0.8}%` }}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    left: '80%',
                                    top: 0,
                                    bottom: 0,
                                    width: '2px',
                                    backgroundColor: '#333',
                                    zIndex: 100
                                }}
                            />
                        </div>
                    </Tooltip>
                    <span className="ProgressBarContainer__value">{precisao} %</span>
                </ProgressBarContainer>

                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 15 }}>
                    <Tooltip title="Ordenar" placement="bottom">
                        <samp>
                            <SortButton sortType={sortType} setSortType={setSortType} />
                        </samp>
                    </Tooltip>
                </div>
            </div>

            {lista_ordenada.map(({ nome_talhao, nome_propriedade, quantidade_planejada, quantidade_executada, porcentagem,
                precisao, atvs_planejadas, atvs_executadas, tipo_fisico, calculo_dosagem }, i) => {
                const isOpen = openAccordion === nome_talhao;
                const atividades = tipo_atividade === 'Planejadas' ? atvs_planejadas : atvs_executadas;
                let tabela_insumos = (estruturaListarInsumos(atividades, unidade_medida_local, data_equipe_cliente, todas_atividades_ativas, tipo_fisico) ?? []);
                return (
                    <Accordion
                        label={<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'left'
                        }}>
                            <span style={{ fontWeight: 600, margin: 0 }}>{nome_talhao}</span>
                            <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>{nome_propriedade}</span>
                        </div>}
                        key={nome_talhao + i + nome_propriedade}
                        open={isOpen}
                        trigger={() => toggleAccordion(nome_talhao)}
                        single
                        extra={
                            <ExtraAccordionStatus
                                quantidade_planejada={quantidade_planejada}
                                quantidade_executada={quantidade_executada}
                                porcentagem={porcentagem}
                                precisao={precisao}
                                tipo_fisico={tipo_fisico}
                                calculo_dosagem={calculo_dosagem}
                            />
                        }
                    >
                        <Tabs
                            tabs={[{ descricao: 'Planejadas', icone: faList }, { descricao: 'Executadas', icone: faClipboardCheck }]}
                            onChange={setTipo_atividade}
                            selecionado={tipo_atividade}
                            width={357}
                        />

                        {(tabela_insumos ?? []).length === 0 ? (
                            <Empty description={`Nenhuma atividade ${tipo_atividade === 'Planejadas' ? 'planejada' : 'executada'}`} image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ margin: '20px 0' }} />
                        ) : (
                            <BodyTable>
                                <HeaderTable
                                    itens={[
                                        { valor: 'Atividade', width: 200 },
                                        { valor: tipo_atividade === 'Executadas' ? 'Operador' : 'Operadores', width: 190 },
                                        { valor: 'Área', width: 100 },
                                        { valor: 'Data', width: 100 },
                                        { valor: 'Tipo', width: 100 },
                                        { valor: 'Dosagem', width: 100 },
                                        { valor: 'Quantidade', width: 130 },
                                    ]}
                                />
                                {tabela_insumos.map(({ nome_atividade, operadores_atv, area, data_atv_inicio,
                                    tipo_uso_nome, quantidade_normalizada, medida_dosagem, dosagem }, i) => {

                                    return (
                                        <RowTable style={{ height: 75 }} key={i + 'insu_deta' + nome_atividade} >
                                            <RowItem width={200} style={{ fontWeight: 600, lineHeight: 1.2 }}>
                                                {nome_atividade}
                                            </RowItem>
                                            <RowItem width={190} style={{ textTransform: 'capitalize' }}>
                                                <div>
                                                    {tipo_atividade === 'Executadas' && (<Tag>{String(operadores_atv).toLowerCase()}</Tag>)}

                                                    {tipo_atividade === 'Planejadas' && (
                                                        (operadores_atv ?? []).map((nome_operador, idx) => {
                                                            return (
                                                                <Tag style={{ marginTop: 3 }} key={idx + 'operador' + nome_operador}>
                                                                    {String(nome_operador)?.toLowerCase()}
                                                                </Tag>
                                                            )
                                                        })
                                                    )}
                                                </div>
                                            </RowItem>
                                            <RowItem width={100}>
                                                {area} ha
                                            </RowItem>
                                            <RowItem width={100}>
                                                {dayjs(data_atv_inicio)?.format("DD/MM/YY")}
                                            </RowItem>
                                            <RowItem width={100} style={{ wordBreak: "break-word", fontSize: 12 }}>
                                                {tipo_uso_nome}
                                            </RowItem>
                                            <RowItem width={100} style={{ flexDirection: 'column', fontSize: 13 }}>
                                                {dosagem} {medida_dosagem}/ha
                                                {calculo_dosagem && <small><b>({calculo_dosagem})</b></small>}
                                            </RowItem>
                                            <RowItem width={130}>
                                                {numeroMilhar(quantidade_normalizada)} {tipo_fisico === 'Sólido' ? 'kg' : 'L'}
                                            </RowItem>
                                        </RowTable>
                                    )
                                })}
                            </BodyTable>
                        )}
                    </Accordion>
                )
            })}
        </Container >
    );
};



interface ExtraAccordionProps {
    quantidade_planejada: number;
    quantidade_executada: number;
    porcentagem: number;
    precisao: number;
    tipo_fisico: string;
    calculo_dosagem: string;
}

const ExtraAccordionStatus: React.FC<ExtraAccordionProps> = ({ quantidade_planejada, quantidade_executada, porcentagem, precisao, tipo_fisico, calculo_dosagem }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <QtdeInoculantes planejada={quantidade_planejada} executada={quantidade_executada} tipo_fisico={tipo_fisico} calculo_dosagem={calculo_dosagem} />
        <ProgressBarContainer style={{ width: '150px', flexDirection: 'row', gap: 2 }}>
            <Tooltip title={`Executado: ${porcentagem}%`}>
                <div className="ProgressBarContainer__bar" style={{ height: '8px', flex: 1 }}>
                    <div
                        className="bar-fill"
                        data-error={precisao < 80}
                        data-warning={precisao >= 80 && precisao < 95}
                        data-small={precisao >= 95 && precisao < 100}
                        data-precise={precisao === 100}
                        style={{ width: `${porcentagem * 0.8}%` }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            left: '80%',
                            top: 0,
                            bottom: 0,
                            width: '2px',
                            backgroundColor: '#333',
                            zIndex: 100
                        }}
                    />
                </div>
            </Tooltip>
            <span className="ProgressBarContainer__value" style={{ fontSize: '12px', color: 'var(--text-color)' }}>{precisao} %</span>
        </ProgressBarContainer>
    </div>
);